import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { userId: String }

  open() {
    document.getElementById(`edit_member_dialog_${this.userIdValue}`)?.showModal()
  }
}
